import { render, staticRenderFns } from "./arrivalIntent.vue?vue&type=template&id=38796c1c&scoped=true&"
import script from "./arrivalIntent.vue?vue&type=script&lang=js&"
export * from "./arrivalIntent.vue?vue&type=script&lang=js&"
import style0 from "./arrivalIntent.vue?vue&type=style&index=0&id=38796c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38796c1c",
  null
  
)

export default component.exports